const ROUTES = {
  HOME: "/",
  TASKS: "/tasks",
  STATUS: "/status",
  SEARCH: "/search",
  MDA: "/mda",
  WATCH_LIST: "/watch-list",
  WATCH_LIST_ADD: "/watch-list/add",
  DATA_CLEANING: "/data-cleaning",
  MONITORING: {
    UNUSED_SQL_OBJECTS: "/monitoring/unused-sql-objects",
  },
  ADMIN: {
    ADMIN: "/admin",
    CONTROL_PANEL: "/admin/control-panel",
    AUDIT: "/admin/audit",
    CACHE: "/admin/cache",
    CLEANING: "/admin/cleaning",
    CLIENTS: "/admin/clients",
    CLIENT_INGESTION: "/admin/ingestion",
    FILE_UPLOAD: "/admin/file-upload",
    JUNK_VALUES: "/admin/junk-values",
    IGNORE_LIST: "/admin/ignore-list",
    SCORING: "/admin/scoring",
    SCORING_RULES: "/admin/scoring/rules",
    CLIENT_SCORING_RULES: "/admin/scoring/client-rules",
    TEMPLATES: "/admin/templates",
    FILTER_OPTIONS: "/admin/filters",
    MDA_SPREADSHEET_MAPPINGS: "/admin/mda/spreadsheet-mappings",
    FILE_MONITOR: "/admin/file-monitor",
    FILE_MONITOR_CLIENTS: "/admin/file-monitor/clients",
    FILE_MONITOR_CLIENT: "/admin/file-monitor/clients/:clientId",
    FILE_EXPLORER: "/admin/file-explorer",
    FILE_EXPLORER_FOLDERS: "/admin/file-explorer/folders",
    FILE_EXPLORER_FOLDER: "/admin/file-explorer/folders/:folderName",
  },
  CALLBACK: "/callback",
  LOGOUT: "/logout",
  LOGOUT_CALLBACK: "/logout/callback",
  SILENT_RENEW: "/silentrenew",
  NOT_AUTHORIZED: "/403",
  NOT_FOUND: "/404",
};

export default ROUTES;
